import degression from 'components/commons/currencies/degression';

export default {
	...degression,
};
